import React, { useState } from 'react';
import Modal from './ui/Modal.jsx';

const EnterNameModal = ({ onClose, onConfirm, title = 'Enter Your Name', placeholder = 'Player Name...', confirmLabel = "Let's Go!" }) => {
    const [name, setName] = useState('');
    const handleSubmit = (e) => {
        e.preventDefault();
        if (name.trim()) {
            onConfirm(name.trim());
        }
    };
    return (
        <Modal title={title} onClose={onClose} size="md" footer={null}>
            <form onSubmit={handleSubmit} className="mt-1 grid gap-3">
                <input
                    type="text"
                    className="rounded-xl bg-slate-800/70 border border-white/10 px-3.5 py-3 text-[16px] text-slate-200"
                    placeholder={placeholder}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoFocus
                />
                <div className="flex justify-end gap-2">
                    <button type="button" className="inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm text-slate-200 bg-slate-800/70 hover:bg-slate-800 ring-1 ring-white/10" onClick={onClose}>Cancel</button>
                    <button type="submit" className="inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm text-white bg-gradient-to-r from-teal-600 to-emerald-600">{confirmLabel}</button>
                </div>
            </form>
        </Modal>
    );
};

export default EnterNameModal;


